import useActions from './useActions'
import { useMemo } from './'

const useNavigate = () => {
  const actions = useActions()

  return useMemo(
    () => ({
      CampaignStoreIndex: actions.openCampaignStore,
      CampaignStoreCategory: ({ categoryId }: { categoryId: string }) => {
        return actions.openCampaignStore(categoryId)
      },
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      push: (action: any, args: any) => action(args),
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      replace: (action: any, args: any) => action(args),
    }),
    [actions],
  )
}

export default useNavigate
